import React, { Component } from 'react'
import './styles/questionTextInput.css'
import '../../../../src/styles/styles.css'
import { HiOutlineThumbUp } from "react-icons/hi"

class QuestionTextInput extends Component {

  constructor (props) {
    super(props)

    this.renderPopularity = this.renderPopularity.bind(this)
  }

  renderPopularity () {
    if (this.props.popularity && this.props.popularity.length) {
      return (
        <span className="fontFamilyBold popularity">
          <HiOutlineThumbUp />
          {this.props.popularity.length}
        </span>
      )
    }
    return null
  }

  render () {
    return (
      <div className="questionTextInput">
        <div className="boxAnswer">
          <span className="fontFamilyBold questionAnswerText">
            {this.props.answer_text}
          </span>
          {this.renderPopularity()}
        </div>
      </div>
    )
  }
}

export default (QuestionTextInput)



// WEBPACK FOOTER //
// ./src/components/questionsWindow/questionTextInput/view.js